// import anime from 'animejs/lib/anime.es';
// import { runInThisContext } from 'vm';

export default class Hamburger {

  constructor(debug = false) {

    this.debug = debug;
    this.TRANSITION_TIME  = 350;

    this.debug && console.log('Hamburger init');

    if (this.setVars()) {
      this.debug && console.log('Hamburger vars init done');
      this.setEvents();
    }
  }

  setVars()
  {
    this.hamburgerEl = document.querySelector('.jsHamburger');
    if (!this.hamburgerEl) return false;

    this.menuEl = document.querySelector('[data-hamburger-menu]');
    if (!this.menuEl) return false;

    this.backdropEl = document.querySelector('[data-hamburger-backdrop]');
    if (!this.backdropEl) return false;

    return true;
  }

  setEvents()
  {
    this.hamburgerEl.addEventListener('click', (e) => {
      e.preventDefault();
      this.onClick();
    });

    this.backdropEl.addEventListener('click', (e) => {
      e.preventDefault();
      this.onBackdropClick();
    });

    window.addEventListener('scrollToClick', (/* e */) => {
      this.closeMenu();
    });
  }

  onClick()
  {
    this.debug && console.log('toggle');
    this.toggleActive();
  }

  onBackdropClick()
  {
    this.debug && console.log('onBackdropClick');
    this.closeMenu();
  }

  toggleActive()
  {
    if (this.hamburgerEl.classList.contains('active')) {
      this.closeMenu();
    }
    else {
      this.openMenu();
    }
  }

  openMenu()
  {
    this.hamburgerEl.classList.add('active');
    this.backdropEl.classList.add('active');
    this.menuEl.classList.add('active');

    // anime({
    //   targets: this.menuEl,
    //   maxHeight: this.getMenuHeight(),
    //   opacity: 1,
    //   duration: this.TRANSITION_TIME,
    //   easing: 'easeInOutQuad',
    // });
  }

  closeMenu()
  {
    this.hamburgerEl.classList.remove('active');
    this.backdropEl.classList.remove('active');
    this.menuEl.classList.remove('active');

    // anime({
    //   targets: this.menuEl,
    //   maxHeight: 0,
    //   opacity: 0,
    //   duration: this.TRANSITION_TIME,
    //   easing: 'easeInOutQuad',
    // });
  }

  getMenuHeight()
  {
    this.menuEl.style.maxHeight = 'initial';
    const menuHeight = this.menuEl.offsetHeight;
    this.menuEl.style.maxHeight = null;

    return menuHeight;
  }
}
